export const CLOAK_PATHS = [
  "/arjan-skyline-by-aqua-properties",
  "/the-community-motor-city-by-aqua-properties",
];

export const PROPERTY_SEARCH_AVAILABILITIES = [
  { value: "available", label: "Available" },
  { value: "prelaunch", label: "Prelaunch" },
  { value: "sold_out", label: "Sold out" },
];

export const PROPERTY_SEARCH_TYPES = [
  { value: "apartment", label: "Apartments" },
  { value: "penthouse", label: "Penthouses" },
  { value: "townhouse", label: "Townhouses" },
  { value: "villa", label: "Villas" },
  { value: "hotel", label: "Hotels" },
];

export const PROPERTY_SEARCH_TYPE_VALUES = {
  apartment: ["apartment", "duplex", "penthouse"],
  penthouse: ["penthouse"],
  townhouse: ["townhouse"],
  villa: ["villa"],
  hotel: ["hotel"],
};

export const SOCIAL_MEDIA_CHANNELS = {
  tiktok: "https://www.tiktok.com/@insidedubaiestate",
  instagram: "https://www.instagram.com/insidedubaiestate/",
  youtube: "https://www.youtube.com/channel/UCSnUeyU546sL7aFscKYeTjQ",
  facebook: "https://www.facebook.com/profile.php?id=100093001644922",
  pinterest: "https://www.pinterest.com/insidedubaiestate/",
  whatsapp: "https://whatsapp.com/channel/0029VaRs93y2v1IjpiNICq2Z",
  telegram: "https://t.me/insidedubaiestate",
};
